import { WifiOff, X } from 'lucide-react';
import { useState, useEffect } from 'react';
import { useOfflineStatus } from '@/hooks/useOfflineStatus';
import { cn } from '@/lib/utils';

export function OfflineBanner() {
  const { isOnline } = useOfflineStatus();
  const [dismissed, setDismissed] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setShow(true);
      setDismissed(false);
    } else {
      // Small delay before hiding to show "back online" message
      const timer = setTimeout(() => setShow(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [isOnline]);

  if (!show || dismissed) return null;

  return (
    <div
      className={cn(
        "fixed top-0 left-0 right-0 z-[100] px-4 py-2 text-center text-sm font-medium transition-all duration-300",
        isOnline
          ? "bg-emerald-600 text-white dark:bg-emerald-500"
          : "bg-destructive text-destructive-foreground"
      )}
    >
      <div className="container mx-auto flex items-center justify-center gap-2 relative">
        {!isOnline ? (
          <>
            <WifiOff className="h-4 w-4" />
            <span>Você está offline. Suas alterações serão salvas localmente.</span>
          </>
        ) : (
          <span>Conexão restaurada! Sincronizando dados...</span>
        )}
        <button
          onClick={() => setDismissed(true)}
          className="absolute right-0 p-1 hover:bg-white/20 rounded transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
